import Todoitem from "./TodoItem";
function TodoList({ todos, deleteTodo, handleComplete }) {
  //   const visibleTodos = todos.filter((todo) => !todo.completed);
  return (
    <ul
      style={{
        listStyleType: "none",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {todos.map((todo) => (
        <Todoitem
          key={todo.id}
          todo={todo}
          deleteTodo={deleteTodo}
          handleComplete={handleComplete}
        ></Todoitem>
      ))}
    </ul>
  );
}
export default TodoList;
